<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns
          .column.is-offset-4.is-4
            .field
              label.label {{ config.question }}
                .control.has-icons-left.has-icons-right
                  input.input.is-primary(
                    type='text', 
                    placeholder='1',
                    v-model="valor"
                  )
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(@click="cerrarModal")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-black.is-rounded(@click="aceptar")
                    | {{ config.textOk }}
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ModalIdProrama',
    props: {
      config: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        valor: 0
      }
    },
    methods: {
      cerrarModal () {
        const obj = {
          save: false,
          valor: 0
        }
        this.valor = 0
        this.$emit('modalEvent', obj)
      },
      aceptar () {
        const obj = {
          save: true,
          valor: this.valor
        }
        this.valor = 0
        this.$emit('modalEvent', obj)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/componentes/ModalIdPrograma.vue